import { Divider as MDivider, DividerProps } from '@mui/material'

export const Divider: React.FC<DividerProps> = (props) => {
  return <MDivider {...props} />
}
